import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "@/components/Primitives";
import { SERVICES, IMAGES } from "@/data";

function PageHeader() {
  return (
    <section className="bg-obsidian text-bone">
      <div className="mx-auto max-w-[1400px] px-6 pb-20 pt-40 lg:px-12 lg:pb-28 lg:pt-52">
        <Reveal>
          <Overline dark>Our Services</Overline>
          <h1 className="mt-8 max-w-4xl font-serif text-5xl leading-[0.95] tracking-tight md:text-7xl">
            Disciplined finance, <span className="italic text-bone/70">end to end.</span>
          </h1>
          <p className="mt-8 max-w-xl text-bone/70 md:text-lg">
            Six practice areas, one standard of rigor. Each engagement is led by a
            senior advisor and aligned to US GAAP expectations.
          </p>
        </Reveal>
      </div>
    </section>
  );
}

export default function Services() {
  return (
    <>
      <PageHeader />

      <section data-testid="services-list" className="mx-auto max-w-[1400px] px-6 lg:px-12">
        {SERVICES.map((s, i) => (
          <Reveal key={s.id}>
            <div
              data-testid={`service-detail-${s.id}`}
              className="grid grid-cols-1 gap-8 border-b border-border py-16 md:grid-cols-12 lg:py-24"
            >
              <div className="md:col-span-1">
                <span className="font-mono text-sm text-brand">[ {s.num} ]</span>
              </div>
              <div className="md:col-span-5">
                <h2 className="font-serif text-3xl tracking-tight text-obsidian md:text-4xl">{s.title}</h2>
                <p className="mt-6 max-w-md leading-relaxed text-stone">{s.desc}</p>
              </div>
              <div className="md:col-span-6 md:pl-10">
                <ul className="grid grid-cols-1 gap-px bg-border sm:grid-cols-2">
                  {s.points.map((p) => (
                    <li key={p} className="bg-bone px-5 py-6 text-sm text-obsidian">
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Reveal>
        ))}
      </section>

      <section className="mx-auto max-w-[1400px] px-6 py-24 lg:px-12 lg:py-36">
        <div className="grid grid-cols-1 items-center gap-12 md:grid-cols-12">
          <Reveal className="md:col-span-6">
            <div className="relative aspect-[4/5] overflow-hidden">
              <img src={IMAGES.advisory} alt="Senior advisors in discussion" className="img-editorial h-full w-full object-cover" />
            </div>
          </Reveal>
          <Reveal delay={0.1} className="md:col-span-6 md:pl-8">
            <Overline>Engagement model</Overline>
            <h2 className="mt-8 font-serif text-4xl leading-tight tracking-tight text-obsidian md:text-5xl">
              Not sure where to <span className="italic">start?</span>
            </h2>
            <p className="mt-6 max-w-md text-stone">
              Most engagements begin with a focused diagnostic. We map your current
              state, identify the highest-leverage work, and propose a clear path
              forward — no obligation.
            </p>
            <Link
              to="/contact"
              data-testid="services-cta"
              className="group mt-10 inline-flex items-center gap-2 bg-obsidian px-8 py-4 text-sm font-medium text-bone transition-colors duration-300 hover:bg-brand"
            >
              Book a Consultation
              <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
